var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getItem, setItem } from "../../utils/asyncStorage.utils";
var ACCESS_TOKEN_KEY = "rentio:auth:access_token";
var REFRESH_TOKEN_KEY = "rentio:auth:refresh_token";
var ACCESS_TOKEN_REFRESH_IN_PROGRESS_KEY = "rentio:auth:access_token_refresh_in_progress";
var ACCESS_TOKEN_LAST_ACCOUNT_SELECT_DATE = "rentio:auth:access_token_last_account_select_date";
export var setAccessToken = function (value) {
    return setItem(ACCESS_TOKEN_KEY, value);
};
export var getAccessToken = function () { return getItem(ACCESS_TOKEN_KEY); };
export var setRefreshToken = function (value) {
    return setItem(REFRESH_TOKEN_KEY, value);
};
export var getRefreshToken = function () { return getItem(REFRESH_TOKEN_KEY); };
export var setAccessTokenRefreshInProgress = function () {
    return setItem(ACCESS_TOKEN_REFRESH_IN_PROGRESS_KEY, "true");
};
export var setAccessTokenRefreshCompleted = function () {
    return setItem(ACCESS_TOKEN_REFRESH_IN_PROGRESS_KEY, undefined);
};
export var getAccessTokenRefreshIsInProgress = function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, getItem(ACCESS_TOKEN_REFRESH_IN_PROGRESS_KEY)];
        case 1: return [2 /*return*/, (_a.sent()) === "true"];
    }
}); }); };
export var setAccessTokenLastAccountSelectDate = function (value) {
    return setItem(ACCESS_TOKEN_LAST_ACCOUNT_SELECT_DATE, value === null || value === void 0 ? void 0 : value.toString());
};
export var getAccessTokenLastAccountSelectDate = function () { return __awaiter(void 0, void 0, void 0, function () {
    var rawResult;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getItem(ACCESS_TOKEN_LAST_ACCOUNT_SELECT_DATE)];
            case 1:
                rawResult = _a.sent();
                if (rawResult) {
                    return [2 /*return*/, new Date(rawResult)];
                }
                return [2 /*return*/, undefined];
        }
    });
}); };
